import flip from 'lodash/flip';
import { naturalCompare } from '../natural-compare';

const withColumn = (sortBy) => (a, b) => naturalCompare(a.get(sortBy), b.get(sortBy));

const makeSort = ({ defaultSort, sortBy, sortDirection }) => {
  if (!sortBy) return typeof defaultSort === 'function' ? defaultSort : () => 0;
  const fortFunc = withColumn(sortBy);
  return sortDirection === 'asc' ? fortFunc : flip(fortFunc);
};

export const makeColumnSort = (query, defaults) => makeSort({ ...defaults, ...query });
